"use client";

import { useState } from "react";

import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import type { NutrafolAcademyCourse } from "@/types/nutrafolAcademy";

import AdditionalCourseModal from "./AdditionalCourseModal";
import CourseCardContent from "./CourseCardContent";

export interface AdditionalCoursesProps {
  courses: NutrafolAcademyCourse[];
}

const AdditionalCourses = ({ courses }: AdditionalCoursesProps) => {
  const [activeCourse, setActiveCourse] = useState<NutrafolAcademyCourse | null>(null);

  return (
    <div>
      <div className="p-2 bg-nova-brand-accent-80 rounded-t text-center">
        <TextElementNova
          text="Want to learn more?"
          classes={{
            default: "Body-10-Dia-Strong",
            1024: "Body-20-Dia-Strong",
          }}
        />
      </div>
      <div className="flex flex-col gap-6 md:gap-4 p-4 md:p-6 xl:p-10 rounded-sm rounded-t-none bg-nova-transparency-white-10 border border-nova-transparency-white-10">
        {courses.map((course, index) => (
          <div
            key={`additional-course-${index}`}
            className="cursor-pointer"
            onClick={() => setActiveCourse(course)}
          >
            <CourseCardContent course={course} tagLabel={course.tag} actionLabel="Watch Video" />
          </div>
        ))}
      </div>
      {activeCourse ? (
        <AdditionalCourseModal course={activeCourse} closeModal={() => setActiveCourse(null)} />
      ) : null}
    </div>
  );
};

export default AdditionalCourses;
